export default __webpack_public_path__ + "static/media/redecormyhome.9ec63e78.png";